import type { Locale } from '~/lib/i18n/shared'
import { Dropdown, Label } from '@heroui/react'
import { Globe } from 'lucide-react'
import { useLocale, useTranslations } from 'use-intl'
import { setLocaleCookie } from '~/lib/i18n/client'
import { implementedLocales, localeNames } from '~/lib/i18n/shared'
import { buildFootballCoreLocalePath } from '~/lib/navigation/football-core'

export function LocaleSwitcher() {
  const currentLocale = useLocale() as Locale
  const t = useTranslations('CommonControls')

  const handleAction = (key: React.Key) => {
    const locale = key as Locale
    setLocaleCookie(locale)

    window.location.href = buildFootballCoreLocalePath(
      locale,
      window.location.pathname,
      window.location.search,
      window.location.hash,
    )
  }

  return (
    <Dropdown>
      <Dropdown.Trigger
        aria-label={t('languageToggle')}
        className="nav-icon-trigger button button--icon-only button--sm button--ghost"
      >
        <Globe className="w-5 h-5" />
      </Dropdown.Trigger>
      <Dropdown.Popover>
        <Dropdown.Menu
          aria-label={t('languageSelection')}
          onAction={handleAction}
          selectedKeys={new Set([currentLocale])}
          selectionMode="single"
        >
          {implementedLocales.map(locale => (
            <Dropdown.Item key={locale} id={locale} textValue={localeNames[locale as Locale]}>
              <Label>{localeNames[locale as Locale]}</Label>
              <Dropdown.ItemIndicator />
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown>
  )
}
